import { useSelector } from 'react-redux';

import { useTextPromoEligibility } from 'hooks/use-text-promo-eligibility';
import { isAtLeastAdmin } from 'store/features/session/selectors';

export function useTextMenuPromoEligibility(): boolean {
  const isEligible = useTextPromoEligibility();
  const isAdminOrOwner = useSelector(isAtLeastAdmin);

  return isEligible && isAdminOrOwner;
}
